/*
 * Author: Roger
 * File Created: Monday, 24-08-05 09:52 pm
 * Last Modified: Saturday, 24-09-14 02:41 pm, by Dw
 */

import {
  Box,
  Button,
  IconButton,
  styled,
  svgIconClasses,
  Typography,
  typographyClasses,
} from '@mui/material';

import { staticImgPrefix } from '@/utils/prefix';

export const MainText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  fontSize: '44px',
  fontWeight: 700,
  lineHeight: '120%',
  [theme.breakpoints.down('md')]: {
    fontSize: '32px',
  },
}));

export const SubText = styled(Typography)(({ theme }) => ({
  color: '#848E9C',
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '120%',
  maxWidth: '410px',
  [theme.breakpoints.down('md')]: {
    fontSize: '14px',
    lineHeight: 'normal',
    marginTop: '16px',
    maxWidth: '343px',
  },
}));

export const ApplyButton = styled(Button)(() => ({
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '120%',
  padding: '12px 20px',

  [`& > .${svgIconClasses.root}`]: {
    width: '20px',
    height: '20px',
    color: 'inherit',
    marginLeft: '4px',
  },
}));

export const Background = styled(Box)(({ theme }) => ({
  backgroundImage: staticImgPrefix('/home/hero-bg.webp'),
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  width: '100%',
  height: '100vh',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1,

  [theme.breakpoints.only('xs')]: {
    height: '300px',
  },
}));

export const Video = styled('video')(() => ({
  position: 'absolute',
  top: 0,
  // left: 0,
  right: 0,
  zIndex: 1,
  objectFit: 'cover',
}));

export const FixedIconButton = styled(IconButton)(({ theme }) => ({
  position: 'fixed',
  bottom: '172px',
  right: '5%',
  zIndex: 2,
  [`& .${svgIconClasses.root}`]: {
    width: '100px',
    height: '100px',
    cursor: 'pointer',
  },
  [theme.breakpoints.only('xs')]: {
    display: 'none',
  },
}));

export const TgbotBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'fixed',
  borderRadius: '94px 0px 0px 94px',
  border: '3px solid #FFF',
  borderRight: 'none',
  padding: '16px 40px 16px 20px',
  background: theme.palette.primary.main,
  bottom: '30px',
  left: '100%',
  transform: 'translateX(-85px)',
  zIndex: 2,
  cursor: 'pointer',
  transition: 'transform 0.3s ease-in-out',
  [theme.breakpoints.only('xs')]: {
    display: 'none',
  },
  [`&:hover`]: {
    transform: 'translateX(-100%)',
  },
  [`& > .${svgIconClasses.root}`]: {
    minWidth: '46px',
    widht: '46px',
    height: '44px',
    color: theme.palette.common.white,
  },
  [`& > .${typographyClasses.root}`]: {
    color: theme.palette.common.white,
    fontSize: '32px',
    fontWeight: 500,
    marginLeft: '20px',
    whiteSpace: 'nowrap',
  },
}));
